
import VueRouter from 'vue-router';
import { Message } from 'element-ui';

const routes = [
    {
        path:'/',
        name:'home',
        component:()=>import('../components/Home')
    },
    {
        path:'/Register',
        name:'register',
        component:()=>import('../components/Register')
    },
    {
        path:'/MiniGames',
        name:'trendToys',
        meta:{
            title:'潮玩天地'
        },
        component:()=>import('../components/MiniGames/MiniGames.vue')
    },
    {
        path:'/Index',
        name:'index',
        redirect:'/Home',
        component:()=>import('../components/AdminLayout'),
        children:[
            {
                path:'/Home',
                name:'home',
                meta:{
                    title:'艺术之窗'
                },
                component:()=>import('../components/ArtWindow/ArtWindow.vue')
            },
        ]
    },
    {
        path:'/GirlMagicBook',
        name:'girlMagicBook',
        component:()=>import('../components/GirlMagicBook/GirlMagicBook.vue')
    },
    {
        path:'/Notes',
        name:'notes',
        meta:{
            title:'裙星空间'
        },
        component:()=>import('../components/Notes/Notes.vue')
    },
    {
        path:'/Storyshop',
        name:'storyshop',
        meta:{
            title:'物语小店'
        },
        component:()=>import('../components/Storyshop/Storyshop.vue')
    },
    {
        path:'/Universe',
        name:'universe',
        meta:{
            title:'宇宙幻境'
        },
        component:()=>import('../components/Universe/Universe.vue')
    },
    {
        path:'/Lolita-JK-HanFu',
        name:'lolita-jk-hanfu',
        meta:{
            title:'粉裙物语'
        },
        component:()=>import('../components/Lolita-JK-HanFu/Lolita-JK-HanFu.vue')
    },
    {
        path:'/World',
        name:'world',
        meta:{
            title:'世界之窗'
        },
        component:()=>import('../components/World/World.vue')
    },
    {
        path:'/Travel',
        name:'travel',
        meta:{
            title:'星际航行'
        },
        component:()=>import('../components/Travel/Travel.vue')
    },
    {
        path:'/MapTracking',
        name:'map-tracking',
        meta:{
            title:'地图相册'
        },
        component:()=>import('../components/MapTracking/MapTracking.vue')
    },
    {
        path:'/LolitaTreasure',
        name:'lolita-treasure',
        meta:{
            title:'洛丽寻宝'
        },
        component:()=>import('../components/LolitaTreasure/LolitaTreasure.vue')
    },
    {
        path:'/Language',
        name:'language',
        meta:{
            title:'英语单词'
        },
        component:()=>import('../components/Language/Language.vue')
    },
    {
        path:'/SpaceDreams',
        name:'spaceDreams',
        meta:{
            title:'梦境空间'
        },
        component:()=>import('../components/Space-Dreams/Space-Dreams.vue')
    },
    {
        path:'/TimeAlbum',
        name:'timeAlbum',
        meta:{
            title:'时光相册'
        },
        component:()=>import('../components/TimeAlbum/TimeAlbum.vue')
    },
    {
        path:'/Memoirs',
        name:'memoirs',
        meta:{
            title:'粉裙星物语'
        },
        component:()=>import('../components/Memoirs/Memoirs.vue')
    },
    {
        path:'/Fireworks',
        name:'fireworks',
        meta:{
            title:'心愿烟花'
        },
        component:()=>import('../components/Fireworks/Fireworks.vue')
    },
]

const router = new VueRouter({
    mode:'history',
    routes
})

// ===== 登录权限控制（仅生产构建 VUE_APP_ACCESS_CONTROL=true 时启用，本地开发不限制）=====
// 限制的页面：“更多”里的功能（潮玩天地/英语记忆/梦境空间/童话魔法/时光相册/心愿烟花）
const ACCESS_CONTROL = process.env.VUE_APP_ACCESS_CONTROL === 'true'
const RESTRICTED_PATHS = ['/MiniGames', '/Language', '/SpaceDreams', '/TimeAlbum', '/Memoirs', '/Fireworks']

router.beforeEach((to, from, next) => {
    if (!ACCESS_CONTROL) {
        next()
        return
    }
    if (RESTRICTED_PATHS.indexOf(to.path) !== -1) {
        let user = null
        try {
            user = JSON.parse(sessionStorage.getItem('CurUser') || 'null')
        } catch (e) {
            user = null
        }
        // 仅超级管理员（roleId=0）可访问
        if (!user || user.roleId !== 0) {
            Message({
                type: 'warning',
                message: '🔒 没有操作权限，请使用超级管理员账号登录后访问',
                duration: 2500
            })
            next('/')
            return
        }
    }
    next()
})

export function resetRouter() {
    router.matcher = new VueRouter({
        mode:'history',
        routes: []
    }).matcher
}
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
export  default router;
